import calendarSvg from '@assets/analytics/calendar.svg?raw';
import chevronDownSvg from '@assets/analytics/chevron-down.svg?raw';
import styles from './fieldStyles.module.css';

interface ITriggerContentProps {
  /** Formatted display text. `null` falls back to the placeholder. */
  display: string | null;
  placeholder: string;
}

/**
 * Inner content of every analytics-page date trigger button:
 * `[calendar svg] [value/placeholder] [chevron svg]`. Sits inside a
 * `Popover.Trigger` (DateField, DateRangeField, DateTimeField). The
 * surrounding trigger element owns the box (border, padding, height),
 * which is in `fieldStyles.module.css`.
 */
export function TriggerContent({ display, placeholder }: ITriggerContentProps) {
  return (
    <>
      <span
        className={styles.leadingIcon}
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: calendarSvg }}
      />
      <span className={display ? styles.value : styles.placeholder}>
        {display ?? placeholder}
      </span>
      <span
        className={styles.trailingIcon}
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: chevronDownSvg }}
      />
    </>
  );
}
